// in the file where you are creating the theme (invoking the function `createTheme()`)

import { amber, blue, green, grey, red } from '@mui/material/colors'

const mode = 'dark'

const theme = {
  palette: {
    // mode: 'light',
    mode,
    ...(mode === 'dark'
      ? {
          background: {
            default: '#303030',
            button: '#424242',
            buttonHover: '#474F4A',
            paper: '#424242',
            color_212121: '#212121',
            color_373636: '#373636',
            red: red[900],
            blue: blue[600],
            green: green[600],
            white: grey[300],
            orange: amber[800],
            grey: grey[600],
            table_row_hover: '#38815775',
            row2: '#2D2D2C',
            chip: '#35353580',
            card: '#282827',
            appBar: '#000000'
          },
          primary: {
            main: '#7FE1A7'
          },
          calendar: {
            systemDefault: '#BDC15C'
          },
          yellow: {
            main: '#facc15',
            light: '#fde047',
            dark: '#eab308',
            contrastText: '#000'
          },
          red: {
            main: '#ff3232'
          }
        }
      : {
          background: {
            default: '#303030',
            button: '#424242',
            buttonHover: '#474F4A',
            paper: '#424242',
            color_212121: '#212121',
            toolbar: '#373636',
            toolbarMultipleSelection: '#43424250'
          },
          warning: {
            main: '#FFB300'
          },

          primary: {
          // light: '#757ce8',
            main: '#FF5733'
            // default: "#7FE1A7",

          // contrastText: '#fff',
          },
          calendar: {
            systemDefault: '#BDC15C'
          }
        }),

    secondary: {
      // light: '#757ce8',
      main: '#FFFFFF',
      darker: '#05fd92'
      // contrastText: '#fff',
    },
    red: {
      main: '#FF0000'
    },
    warning: {
      main: '#ED6C02'
    },
    pending: {
      main: '#FFBF00'
    },
    error: {
      main: '#F68D76'
    },
    info: {
      main: '#0688D1'
    },
    // edit: {
    //     main: '#FFFF00'
    // },
    action: {
      // hover:"#05fd9250",
      hover: '#00000020',
      selected: '#00000050'
    },
    manual_action: '#FFFF00'
  },
  tokens: {
    spacing: {
      xs: 4,
      sm: 8,
      md: 12,
      lg: 16,
      xl: 24
    },
    radius: {
      sm: 8,
      md: 12,
      lg: 16
    },
    typography: {
      fontFamily: 'Inter, Roboto, Helvetica, Arial, sans-serif',
      h1: 24,
      h2: 20,
      h3: 18,
      body: 14,
      caption: 12
    },
    elevation: {
      card: 1,
      panel: 2
    }
  },
  components: {
    MuiToggleButton: {
      styleOverrides: {
        root: {
          border: '0.5px solid #00000020',
          color: '#AAAAAA'
        }
      }
    }
  },
  dateFormats: {
    es: { date: 'dd/MM/yyyy', dateTime: 'dd/MM/yyyy HH:mm', time: 'HH:mm' },
    eus: { date: 'yyyy/MM/dd', dateTime: 'yyyy/MM/dd HH:mm', time: 'HH:mm' },
    pt: { date: 'dd/MM/yyyy', dateTime: 'dd/MM/yyyy HH:mm', time: 'HH:mm' },
    ca: { date: 'dd/MM/yyyy', dateTime: 'dd/MM/yyyy HH:mm', time: 'HH:mm' },
    fr: { date: 'dd/MM/yyyy', dateTime: 'dd/MM/yyyy HH:mm', time: 'HH:mm' },
    en: { date: 'MM/dd/yyyy', dateTime: 'MM/dd/yyyy HH:mm', time: 'HH:mm' },
    lv: { date: 'MM/dd/yyyy', dateTime: 'MM/dd/yyyy HH:mm', time: 'HH:mm' }
  }
}

export default theme
